// PeptideVault v6.5 — Injection supplies + locations

// ══════════════════════════════════════════════════════
// RENDER: INJECTION SUPPLIES & PEPTIDE PENS TAB
// ══════════════════════════════════════════════════════

const INJ_SUPPLY_CATEGORIES_DEFAULT = ['Pen Needles','BAC Water','Syringes','Alcohol Swabs','Sharps Container','Bandages','Mixing Supplies','Other']
function injSupplyCategories() {
  const cats = new Set(INJ_SUPPLY_CATEGORIES_DEFAULT)
  for (const s of (S.injectionSupplies || [])) { if (s.category) cats.add(s.category) }
  return [...cats].sort()
}

function injSupplyQty(sku) {
  if (!sku.transactions?.length) return 0
  return sku.transactions.reduce((a, t) => a + (t.type === 'in' ? +t.qty : -+t.qty), 0)
}
function injSupplyTotalQty(supply) {
  return (supply.skus || []).reduce((a, s) => a + injSupplyQty(s), 0)
}
function lowStockSupplies() {
  return S.injectionSupplies.filter(s => {
    const thresh = +(s.lowStockThreshold || 0)
    return thresh > 0 && injSupplyTotalQty(s) <= thresh
  })
}
function getInjSupply(id) { return S.injectionSupplies.find(s => s.id === id) }
function getInjSku(supplyId, skuId) {
  const s = getInjSupply(supplyId)
  return s?.skus?.find(sk => sk.id === skuId)
}

function supplyLocationName(locationId) {
  return (S.storageLocations || []).find(l => l.id === locationId)?.name || 'Unknown location'
}

function renderSupplyStorageView() {
  const locations = new Map()
  let locatedQty = 0, unlocatedQty = 0, placedSkus = 0
  for (const supply of (S.injectionSupplies || [])) for (const sku of (supply.skus || [])) {
    const stock = Math.max(0, injSupplyQty(sku))
    const placed = (sku.locations || []).filter(x => +x.qty > 0)
    const placedTotal = placed.reduce((n, x) => n + (+x.qty || 0), 0)
    if (placed.length) placedSkus++
    locatedQty += placedTotal
    unlocatedQty += Math.max(0, stock - placedTotal)
    for (const item of placed) {
      if (!locations.has(item.locationId)) locations.set(item.locationId, { id:item.locationId, name:supplyLocationName(item.locationId), rows:[], total:0 })
      const group = locations.get(item.locationId)
      group.rows.push({ supply, sku, qty:+item.qty })
      group.total += +item.qty
    }
  }
  const groups = [...locations.values()].sort((a,b) => a.name.localeCompare(b.name))
  return `<div>
    <div class="row" style="align-items:center;margin-bottom:16px;gap:10px;flex-wrap:wrap">
      <div><h2 style="font-size:20px;font-weight:700;margin:0">Supply Storage</h2><div style="font-size:13px;color:var(--text3);margin-top:4px">See exactly where every supply SKU is stored.</div></div>
      <div class="spacer"></div>
      <button class="btn btn-secondary btn-sm" onclick="S._supplyView='inventory';render()">Inventory</button>
      <button class="btn btn-primary btn-sm">Storage</button>
    </div>
    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:10px;margin-bottom:16px">
      <div class="card" style="padding:14px"><div style="font-size:24px;font-weight:750">${groups.length}</div><div style="font-size:12px;color:var(--text3)">storage locations</div></div>
      <div class="card" style="padding:14px"><div style="font-size:24px;font-weight:750">${locatedQty}</div><div style="font-size:12px;color:var(--text3)">units located</div></div>
      <div class="card" style="padding:14px"><div style="font-size:24px;font-weight:750">${placedSkus}</div><div style="font-size:12px;color:var(--text3)">SKUs placed</div></div>
      <div class="card" style="padding:14px;border-color:${unlocatedQty?'var(--amber)':'var(--border)'}"><div style="font-size:24px;font-weight:750;color:${unlocatedQty?'var(--amber)':'var(--text)'}">${unlocatedQty}</div><div style="font-size:12px;color:var(--text3)">units not assigned</div></div>
    </div>
    ${groups.length ? `<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,320px),1fr));gap:12px">${groups.map(group => `<section class="card" style="overflow:hidden">
      <div class="card-header"><div><div class="card-title">📍 ${esc(group.name)}</div><div style="font-size:12px;color:var(--text3)">${group.rows.length} SKU${group.rows.length===1?'':'s'}</div></div><strong>${group.total} EA</strong></div>
      <div>${group.rows.sort((a,b)=>(a.supply.name||'').localeCompare(b.supply.name||'')).map(row => `<button style="width:100%;border:0;border-top:1px solid var(--border);background:transparent;padding:11px 14px;text-align:left;color:var(--text);cursor:pointer;display:grid;grid-template-columns:1fr auto;gap:10px" onclick="S._supplyView='inventory';S._selectedInjSupply='${row.supply.id}';render()">
        <span><b style="display:block">${esc(row.supply.name)}</b><small style="color:var(--text3)">${esc([row.sku.vendor,row.sku.lotNumber && 'Lot '+row.sku.lotNumber,row.sku.volume,row.sku.gauge].filter(Boolean).join(' · ') || 'SKU')}</small></span><strong>${row.qty}</strong>
      </button>`).join('')}</div>
    </section>`).join('')}</div>` : `<div class="card"><div class="empty-state" style="padding:42px"><div class="empty-icon">📍</div><p>No supply inventory is assigned to storage yet</p><span>Edit a supply SKU to assign its quantities to a location.</span></div></div>`}
  </div>`
}

function renderInjSuppliesTab() {
  if (S._supplyView === 'storage') return `<div class="tab-content">${renderSupplyStorageView()}</div>`
  const supplies = S.injectionSupplies || []
  const activeSupplies = supplies.filter(s => !(s.skus||[]).length || (s.skus||[]).some(sk => injSupplyQty(sk) > 0))
  const depletedGroups = supplies.map(s => ({ supply:s, skus:(s.skus||[]).filter(sk => injSupplyQty(sk) <= 0) })).filter(group => group.skus.length)
  const depletedCount = depletedGroups.reduce((count, group) => count + group.skus.length, 0)

  return `<div class="tab-content">
    <div class="row" style="align-items:center;margin-bottom:16px;flex-wrap:wrap;gap:10px">
      <h2 style="font-size:20px;font-weight:700;margin:0">Injection Supplies</h2>
      <div class="spacer"></div>
      <button class="btn btn-secondary btn-sm" onclick="S._supplyView='storage';render()">📍 Supply Storage</button>
      <button class="btn btn-secondary btn-sm" onclick="exportInjSuppliesCSV()">${ICONS.export} Export Supplies</button>
      <button class="btn btn-primary btn-sm" onclick="openModal('addInjSupply')">+ Add Supply</button>
    </div>

    <!-- Supply list -->
    ${activeSupplies.length === 0 ? `<div class="card"><div class="empty-state" style="padding:48px"><div class="empty-icon">📦</div><p>No active injection supplies</p><span>Click "+ Add Supply" or restore stock from Depleted Inventory</span></div></div>` : `
    <div class="card" style="margin-bottom:24px">
      ${[...activeSupplies].sort((a,b) => (a.name||'').localeCompare(b.name||'')).map((s, idx) => {
        // Sort SKUs: by gauge (numeric), then volume, then expiry (soonest first)
        const sortedSkus = [...(s.skus||[])].filter(sk => injSupplyQty(sk) > 0).sort((a,b) => {
          // Gauge: parse numeric (29g → 29), smaller gauge number first
          const ga = parseFloat(a.gauge||a.sizeGauge||'999'), gb = parseFloat(b.gauge||b.sizeGauge||'999')
          if (ga !== gb) return ga - gb
          // Needle length
          const la = parseFloat(a.needleLength||'999'), lb = parseFloat(b.needleLength||'999')
          if (la !== lb) return la - lb
          // Volume: parse numeric mL value
          const va = parseFloat(a.volume) || 999, vb = parseFloat(b.volume) || 999
          if (va !== vb) return va - vb
          // Expiry: soonest first, no-expiry at bottom
          const ea = a.expiryDate || '9999', eb = b.expiryDate || '9999'
          return ea.localeCompare(eb)
        })
        const total = injSupplyTotalQty(s)
        const thresh = +(s.lowStockThreshold || 0)
        const low = thresh > 0 && total <= thresh
        const expanded = S._selectedInjSupply === s.id
        const skuCount = sortedSkus.length
        const rowFlag = low ? 'border-left:3px solid var(--amber)' : 'border-left:3px solid transparent'
        // Gather summary for collapsed view
        const volumes = [...new Set((s.skus||[]).map(sk=>sk.volume).filter(Boolean))]
        return `
        <div style="${rowFlag};${idx>0?'border-top:1px solid var(--border)':''}">
          <div style="display:grid;grid-template-columns:1fr auto;align-items:center;gap:12px;padding:12px 16px;cursor:pointer" onclick="S._selectedInjSupply=S._selectedInjSupply==='${s.id}'?null:'${s.id}';render()">
            <div>
              <div class="pep-name">${esc(s.name)}</div>
              <div class="pep-meta">
                ${s.category ? esc(s.category) + ' · ' : ''}${skuCount} SKU${skuCount!==1?'s':''}${volumes.length ? ' · ' + esc(volumes.join(', ')) : ''}
              </div>
            </div>
            <div style="display:flex;align-items:center;gap:10px;text-align:right">
              <button class="btn btn-ghost btn-xs" style="color:var(--red)" onclick="event.stopPropagation();deleteInjSupply('${s.id}')" title="Delete ${esc(s.name)}">Delete</button>
              <div>
              <div style="font-size:20px;font-weight:700;color:${low?'var(--amber)':'var(--text)'}">${total}<span style="font-size:13px;font-weight:400;color:var(--text3);margin-left:3px">EA</span></div>
              <div style="font-size:11px;color:var(--text4)">total qty</div>
              </div>
            </div>
          </div>
          ${expanded ? `
          <div style="padding:0 16px 12px">
            <div class="row" style="gap:8px;margin-bottom:10px;flex-wrap:wrap">
              <button class="btn btn-secondary btn-xs" onclick="openModal('addInjSku',{supplyId:'${s.id}'})">+ Add SKU</button>
              <button class="btn btn-ghost btn-xs" onclick="openModal('editInjSupply',{supplyId:'${s.id}'})">${ICONS.edit} Edit</button>
              <button class="btn btn-ghost btn-xs" style="color:var(--red)" onclick="deleteInjSupply('${s.id}')">Delete</button>
            </div>
            ${sortedSkus.length === 0 ? '<div style="color:var(--text4);font-size:12px;padding:8px">No SKUs — add one above</div>' :
              sortedSkus.map(sk => {
                const qty = injSupplyQty(sk)
                return `
            <div style="padding:8px 10px;background:var(--bg3);border-radius:var(--r2);margin-bottom:6px;font-size:13px;${qty<=0?'opacity:.62':''}">
              <div class="row" style="align-items:center;gap:8px;flex-wrap:wrap">
                <span style="font-weight:600;color:var(--text)">${esc(sk.vendor||'—')}</span>
                ${sk.volume ? `<span class="badge badge-blue" style="font-size:11px">${esc(sk.volume)}</span>` : ''}
                ${sk.gauge ? `<span class="badge badge-gray" style="font-size:11px">${esc(sk.gauge)}</span>` : ''}
                ${sk.needleLength ? `<span class="badge badge-gray" style="font-size:11px">${esc(sk.needleLength)}</span>` : ''}
                ${!sk.gauge && sk.sizeGauge ? `<span class="badge badge-gray" style="font-size:11px">${esc(sk.sizeGauge)}</span>` : ''}
                ${sk.lotNumber ? `<span style="font-size:11px;color:var(--text4)">Lot: ${esc(sk.lotNumber)}</span>` : ''}
                ${sk.expiryDate ? `<span style="font-size:11px;color:var(--text4)">Exp: ${sk.expiryDate.slice(0,10)}</span>` : ''}
                ${sk.barcode ? `<span class="mono" style="font-size:11px;color:var(--text4)">▌${esc(sk.barcode)}</span>` : ''}
                ${(sk.locations||[]).filter(l=>+l.qty>0).map(l=>`<span class="badge badge-blue" style="font-size:10px">📍 ${esc(supplyLocationName(l.locationId))}: ${+l.qty}</span>`).join('')}
                <div class="spacer"></div>
                ${qty<=0?'<span class="badge badge-gray" style="font-size:10px">Depleted</span>':''}<span style="font-size:14px;font-weight:700">${qty}</span>
                <button class="btn btn-ghost btn-xs" onclick="openModal('editInjSku',{supplyId:'${s.id}',skuId:'${sk.id}'})">${ICONS.edit}</button>
              </div>
              <div class="row" style="gap:6px;margin-top:6px">
                <input class="form-input" id="in_isk_${sk.id}" type="number" min="1" value="1" style="width:60px;text-align:center;font-size:12px;padding:4px">
                <button class="btn btn-secondary btn-xs" onclick="adjInjSku('${s.id}','${sk.id}','in')">+ In</button>
                <button class="btn btn-secondary btn-xs" onclick="adjInjSku('${s.id}','${sk.id}','out')">− Out</button>
                ${sk.reorderUrl ? `<button class="btn btn-ghost btn-xs" onclick="openPepPedia('${esc(sk.reorderUrl)}')">🛒</button>` : ''}
              </div>
            </div>`}).join('')}
          </div>` : ''}
        </div>`}).join('')}
    </div>`}

    ${depletedCount ? `<section class="card" style="margin-top:16px;overflow:hidden">
      <button style="width:100%;display:flex;align-items:center;gap:10px;padding:14px 16px;border:0;background:transparent;color:var(--text);cursor:pointer;text-align:left" onclick="S._showDepletedSupplies=!S._showDepletedSupplies;render()" aria-expanded="${S._showDepletedSupplies?'true':'false'}">
        <span style="font-size:13px;transform:rotate(${S._showDepletedSupplies?'90':'0'}deg);transition:transform .15s">▶</span>
        <span style="font-weight:700">Depleted Inventory</span>
        <span class="badge badge-gray">${depletedCount} SKU${depletedCount===1?'':'s'}</span>
        <span style="margin-left:auto;font-size:12px;color:var(--text4)">History retained</span>
      </button>
      ${S._showDepletedSupplies ? `<div style="border-top:1px solid var(--border);padding:8px 16px 14px">
        ${depletedGroups.sort((a,b)=>(a.supply.name||'').localeCompare(b.supply.name||'')).map(group => `<div style="padding:10px 0;border-bottom:1px solid var(--border)">
          <div style="font-weight:700;margin-bottom:7px">${esc(group.supply.name)}</div>
          ${group.skus.map(sk => `<div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;padding:7px 9px;margin-bottom:5px;background:var(--bg3);border-radius:var(--r2);opacity:.78">
            <span style="font-weight:600">${esc(sk.vendor||'—')}</span>
            ${sk.lotNumber?`<span style="font-size:11px;color:var(--text4)">Lot: ${esc(sk.lotNumber)}</span>`:''}
            ${sk.volume?`<span class="badge badge-gray">${esc(sk.volume)}</span>`:''}
            ${sk.gauge?`<span class="badge badge-gray">${esc(sk.gauge)}</span>`:''}
            <span class="badge badge-gray">Depleted</span>
            <div class="spacer"></div>
            <input class="form-input" id="in_isk_${sk.id}" type="number" min="1" value="1" style="width:60px;text-align:center;font-size:12px;padding:4px">
            <button class="btn btn-secondary btn-xs" onclick="adjInjSku('${group.supply.id}','${sk.id}','in')">+ Restock</button>
            <button class="btn btn-ghost btn-xs" onclick="openModal('editInjSku',{supplyId:'${group.supply.id}',skuId:'${sk.id}'})">${ICONS.edit}</button>
          </div>`).join('')}
        </div>`).join('')}
      </div>` : ''}
    </section>` : ''}
  </div>`
}

function renderPensTab() {
  const pens = S.peptidePens || []
  return `<div class="tab-content">
    <div class="row" style="align-items:center;margin-bottom:12px">
      <div><h2 style="font-size:20px;font-weight:700;margin:0">Injection Pens</h2><div style="font-size:13px;color:var(--text3);margin-top:4px">Manage reusable pens and their linked peptides separately from disposable supplies.</div></div>
      <div class="spacer"></div>
      <button class="btn btn-primary btn-sm" onclick="openModal('addPen')">+ Add Pen</button>
    </div>
    ${pens.length === 0 ? `<div style="color:var(--text4);text-align:center;padding:24px">No pens yet — add your first pen above</div>` : `
    <div class="card">
      ${[...pens].sort((a,b) => {
        const aLinked = (a.linkedPeptideIds||[]).length > 0
        const bLinked = (b.linkedPeptideIds||[]).length > 0
        if (aLinked && !bLinked) return -1
        if (!aLinked && bLinked) return 1
        if (aLinked && bLinked) {
          const aName = (a.linkedPeptideIds||[]).map(pid => getPeptide(pid)?.name||'').sort()[0] || ''
          const bName = (b.linkedPeptideIds||[]).map(pid => getPeptide(pid)?.name||'').sort()[0] || ''
          return aName.localeCompare(bName)
        }
        const bc = (a.brand||'').localeCompare(b.brand||'')
        return bc !== 0 ? bc : (a.model||'').localeCompare(b.model||'')
      }).map((pen, idx) => {
        const linkedNames = (pen.linkedPeptideIds||[]).map(pid => { const p = getPeptide(pid); return p ? p.name : '?' }).filter(Boolean)
        const statusColor = pen.status === 'active' ? 'green' : pen.status === 'broken' ? 'red' : 'gray'
        const userName = pen.userId === 'both' ? 'Both' : pen.userId ? (S.users||[]).find(u=>u.id===pen.userId)?.name : ''
        return `
        <div style="display:grid;grid-template-columns:1fr auto;align-items:center;gap:12px;padding:12px 16px;${idx>0?'border-top:1px solid var(--border)':''}">
          <div>
            <div class="pep-name">🖊️ ${esc(pen.labelName || pen.model || pen.brand || 'Pen')}${pen.penTrackingId ? ` <span class="badge badge-blue">${esc(pen.penTrackingId)}</span>` : ''}</div>
            <div class="pep-meta">
              ${[pen.brand, pen.model, pen.penUnits ? pen.penUnits + ' units' : '', pen.color, pen.needsSpacer ? 'Spacer needed' : '', userName].filter(Boolean).join(' · ')}
            </div>
            ${linkedNames.length ? `<div style="display:flex;flex-wrap:wrap;gap:3px;margin-top:4px">${linkedNames.map(n => `<span class="badge badge-blue" style="font-size:10px">${esc(n)}</span>`).join('')}</div>` : ''}
          </div>
          <div style="display:flex;align-items:center;gap:8px">
            <span class="badge badge-${statusColor}">${esc(pen.status||'active')}</span>
            <button class="btn btn-ghost btn-xs" onclick="openModal('editPen',{penId:'${pen.id}'})">${ICONS.edit}</button>
            <button class="btn btn-ghost btn-xs" style="color:var(--red)" onclick="deletePen('${pen.id}')">Delete</button>
          </div>
        </div>`}).join('')}
    </div>`}
  </div>`
}

// Injection Supply CRUD
function adjInjSku(supplyId, skuId, type) {
  const sk = getInjSku(supplyId, skuId)
  if (!sk) return
  const inputId = `in_isk_${skuId}`
  const qty = +(document.getElementById(inputId)?.value || 1)
  if (qty <= 0) { showToast('Enter a valid quantity'); return }
  if (type === 'out' && injSupplyQty(sk) < qty) { showToast('Not enough stock'); return }
  if (type === 'out') {
    const located = (sk.locations || []).reduce((n,l) => n + (+l.qty || 0), 0)
    S._injSupplyPull = { supplyId, skuId, qty, unlocated:Math.max(0, injSupplyQty(sk) - located) }
    openModal('pullInjSupplyLocation')
    return
  }
  if (!sk.transactions) sk.transactions = []
  sk.transactions.push({ id:'t_'+uid(), type, qty, date:now(), notes:'' })
  if (type === 'out') {
    // Smart decrement: unlocated first
    const locTotal = (sk.locations||[]).reduce((a,l) => a+(l.qty||0), 0)
    const preRemoval = injSupplyQty(sk) + qty
    const unlocated = Math.max(0, preRemoval - locTotal)
    let remaining = Math.max(0, qty - unlocated)
    if (remaining > 0 && sk.locations?.length) {
      for (const loc of sk.locations) {
        if (remaining <= 0) break
        const take = Math.min(loc.qty||0, remaining)
        loc.qty = (loc.qty||0) - take; remaining -= take
      }
      sk.locations = sk.locations.filter(l => (l.qty||0) > 0)
    }
  } else if (type === 'in' && sk.locations?.length) {
    sk.locations[0].qty = (sk.locations[0].qty||0) + qty
  }
  save(); render()
  showToast(`${type==='in'?'Added':'Removed'} ${qty} EA`)
}

function updateInjSupplyPullTotal(target) {
  const ctx = S._injSupplyPull
  const sk = ctx && getInjSku(ctx.supplyId, ctx.skuId)
  if (!sk) return
  let total = +(document.getElementById('is-pull-__unlocated__')?.value || 0)
  for (const l of (sk.locations || [])) total += +(document.getElementById(`is-pull-${l.locationId}`)?.value || 0)
  const hint = document.getElementById('is-pull-total-hint')
  if (hint) hint.innerHTML = total === target ? `<span style="color:var(--green);font-weight:600">✓ ${total} of ${target}</span>` : `<span style="color:${total>target?'var(--red)':'var(--text3)'}">${total} of ${target}${total>target?' — too many':''}</span>`
}

function confirmInjSupplyPull() {
  const ctx = S._injSupplyPull
  const sk = ctx && getInjSku(ctx.supplyId, ctx.skuId)
  if (!ctx || !sk) { closeModal(); return }
  const pulls = []; let total = 0; const notes = []
  const unlocated = +(document.getElementById('is-pull-__unlocated__')?.value || 0)
  if (unlocated > ctx.unlocated) { showToast('Not enough unassigned inventory'); return }
  total += unlocated
  if (unlocated) notes.push(`${unlocated} from Not assigned`)
  for (const l of (sk.locations || [])) {
    const amount = +(document.getElementById(`is-pull-${l.locationId}`)?.value || 0)
    if (amount > +l.qty) { showToast(`Not enough inventory at ${supplyLocationName(l.locationId)}`); return }
    if (amount > 0) { pulls.push({ l, amount }); total += amount; notes.push(`${amount} from ${supplyLocationName(l.locationId)}`) }
  }
  if (total !== ctx.qty) { showToast(`Choose locations totaling ${ctx.qty}`); return }
  for (const pull of pulls) pull.l.qty = (+pull.l.qty || 0) - pull.amount
  sk.locations = (sk.locations || []).filter(l => +l.qty > 0)
  sk.transactions ||= []
  sk.transactions.push({ id:'t_'+uid(), type:'out', qty:ctx.qty, date:now(), notes:`Removed: ${notes.join(', ')}` })
  S._injSupplyPull = null
  save(); closeModal(); render(); showToast(`Removed ${ctx.qty} EA (${notes.join(', ')})`)
}

function saveAddInjSupply() {
  const name = document.getElementById('f-is-name')?.value?.trim()
  if (!name) { showToast('Name is required'); return }
  const s = {
    id: 'is_'+uid(), name,
    category: (document.getElementById('f-is-category')?.value === '__custom__' ? document.getElementById('f-is-cat-custom')?.value?.trim() : document.getElementById('f-is-category')?.value) || '',
    description: document.getElementById('f-is-desc')?.value?.trim() || '',
    lowStockThreshold: +(document.getElementById('f-is-low')?.value || 0),
    expiryDate: document.getElementById('f-is-exp')?.value || '',
    isSyringeNeedle: document.getElementById('f-is-syringe')?.checked || false,
    skus: []
  }
  S.injectionSupplies.push(s)
  S._selectedInjSupply = s.id
  save(); closeModal(); render(); showToast('Supply added')
}

function saveEditInjSupply(supplyId) {
  const s = getInjSupply(supplyId)
  if (!s) return
  s.name = document.getElementById('f-is-name')?.value?.trim() || s.name
  s.category = (document.getElementById('f-is-category')?.value === '__custom__' ? document.getElementById('f-is-cat-custom')?.value?.trim() : document.getElementById('f-is-category')?.value) || ''
  s.description = document.getElementById('f-is-desc')?.value?.trim() || ''
  s.lowStockThreshold = +(document.getElementById('f-is-low')?.value || 0)
  s.expiryDate = document.getElementById('f-is-exp')?.value || ''
  s.isSyringeNeedle = document.getElementById('f-is-syringe')?.checked || false
  save(); closeModal(); render(); showToast('Supply updated')
}

async function deleteInjSupply(id) {
  if (!await asyncConfirm('Delete this supply and all its SKUs?')) return
  S.injectionSupplies = S.injectionSupplies.filter(s => s.id !== id)
  S._selectedInjSupply = null
  save(); render(); showToast('Supply deleted')
}

function saveAddInjSku(supplyId) {
  const s = getInjSupply(supplyId)
  if (!s) return
  if (!s.skus) s.skus = []
  const qty = +(document.getElementById('f-isk-qty')?.value || 0)
  const sk = {
    id: 'isk_'+uid(),
    barcode: document.getElementById('f-isk-barcode')?.value?.trim() || '',
    vendor: document.getElementById('f-isk-vendor')?.value?.trim() || '',
    lotNumber: document.getElementById('f-isk-lot')?.value?.trim() || '',
    sizeGauge: document.getElementById('f-isk-size')?.value?.trim() || '',
    volume: document.getElementById('f-isk-vol')?.value?.trim() || '',
    gauge: document.getElementById('f-isk-gauge')?.value?.trim() || '',
    needleLength: document.getElementById('f-isk-needle-len')?.value?.trim() || '',
    expiryDate: document.getElementById('f-isk-exp')?.value || '',
    costPerUnit: document.getElementById('f-isk-cost')?.value?.trim() || '',
    reorderUrl: document.getElementById('f-isk-reorder')?.value?.trim() || '',
    niimLabel: document.getElementById('f-isk-niimlabel')?.value?.trim() || '',
    niimQR: document.getElementById('f-isk-niimqr')?.value?.trim() || '',
    locations: [],
    transactions: qty > 0 ? [{ id:'t_'+uid(), type:'in', qty, date:now(), notes:'Initial stock' }] : []
  }
  // Location assignments
  for (let i = 0; i < 5; i++) {
    const locId = document.getElementById(`f-isk-loc-id-${i}`)?.value
    const locQty = +(document.getElementById(`f-isk-loc-qty-${i}`)?.value || 0)
    if (locId && locQty > 0) sk.locations.push({ locationId: locId, qty: locQty })
  }
  s.skus.push(sk)
  save(); closeModal(); render(); showToast('SKU added')
}

function saveEditInjSku(supplyId, skuId) {
  const sk = getInjSku(supplyId, skuId)
  if (!sk) return
  sk.barcode = document.getElementById('f-isk-barcode')?.value?.trim() || ''
  sk.vendor = document.getElementById('f-isk-vendor')?.value?.trim() || ''
  sk.lotNumber = document.getElementById('f-isk-lot')?.value?.trim() || ''
  sk.sizeGauge = document.getElementById('f-isk-size')?.value?.trim() || ''
  sk.volume = document.getElementById('f-isk-vol')?.value?.trim() || ''
  sk.gauge = document.getElementById('f-isk-gauge')?.value?.trim() || ''
  sk.needleLength = document.getElementById('f-isk-needle-len')?.value?.trim() || ''
  sk.expiryDate = document.getElementById('f-isk-exp')?.value || ''
  sk.costPerUnit = document.getElementById('f-isk-cost')?.value?.trim() || ''
  sk.reorderUrl = document.getElementById('f-isk-reorder')?.value?.trim() || ''
  sk.niimLabel = document.getElementById('f-isk-niimlabel')?.value?.trim() || ''
  sk.niimQR = document.getElementById('f-isk-niimqr')?.value?.trim() || ''
  sk.locations = []
  for (let i = 0; i < 5; i++) {
    const locId = document.getElementById(`f-isk-loc-id-${i}`)?.value
    const locQty = +(document.getElementById(`f-isk-loc-qty-${i}`)?.value || 0)
    if (locId && locQty > 0) sk.locations.push({ locationId: locId, qty: locQty })
  }
  save(); closeModal(); render(); showToast('SKU updated')
}

// Peptide Pen CRUD
function saveAddPen() {
  const pen = {
    id: 'pp_'+uid(),
    penTrackingId: document.getElementById('f-pen-tracking')?.value?.trim() || '',
    brand: document.getElementById('f-pen-brand')?.value?.trim() || '',
    model: document.getElementById('f-pen-model')?.value?.trim() || '',
    penUnits: document.getElementById('f-pen-units')?.value?.trim() || '',
    needsSpacer: document.getElementById('f-pen-spacer')?.checked || false,
    labelName: document.getElementById('f-pen-label')?.value?.trim() || '',
    color: document.getElementById('f-pen-color')?.value?.trim() || '',
    userId: document.getElementById('f-pen-user')?.value || '',
    linkedPeptideIds: Array.from(document.querySelectorAll('.pen-pep-cb:checked')).map(el => el.value),
    status: 'active',
    notes: document.getElementById('f-pen-notes')?.value?.trim() || '',
    createdAt: now(), updatedAt: now()
  }
  S.peptidePens.push(pen)
  save(); closeModal(); render(); showToast('Pen added')
}

function saveEditPen(penId) {
  const pen = S.peptidePens.find(p => p.id === penId)
  if (!pen) return
  pen.penTrackingId = document.getElementById('f-pen-tracking')?.value?.trim() || ''
  pen.brand = document.getElementById('f-pen-brand')?.value?.trim() || ''
  pen.model = document.getElementById('f-pen-model')?.value?.trim() || ''
  pen.penUnits = document.getElementById('f-pen-units')?.value?.trim() || ''
  pen.needsSpacer = document.getElementById('f-pen-spacer')?.checked || false
  pen.labelName = document.getElementById('f-pen-label')?.value?.trim() || ''
  pen.color = document.getElementById('f-pen-color')?.value?.trim() || ''
  pen.userId = document.getElementById('f-pen-user')?.value || ''
  pen.linkedPeptideIds = Array.from(document.querySelectorAll('.pen-pep-cb:checked')).map(el => el.value)
  pen.status = document.getElementById('f-pen-status')?.value || 'active'
  pen.notes = document.getElementById('f-pen-notes')?.value?.trim() || ''
  pen.updatedAt = now()
  save(); closeModal(); render(); showToast('Pen updated')
}

function deletePen(id) {
  appConfirm('Delete this pen?', () => {
    S.peptidePens = S.peptidePens.filter(p => p.id !== id)
    save(); render(); showToast('Pen deleted')
  })
}

// ══════════════════════════════════════════════════════
// RENDER: LOCATIONS TAB
// ══════════════════════════════════════════════════════

export {
  INJ_SUPPLY_CATEGORIES_DEFAULT,
  injSupplyCategories,
  injSupplyQty,
  injSupplyTotalQty,
  lowStockSupplies,
  getInjSupply,
  getInjSku,
  renderInjSuppliesTab,
  renderSupplyStorageView,
  renderPensTab,
  adjInjSku,
  updateInjSupplyPullTotal,
  confirmInjSupplyPull,
  saveAddInjSupply,
  saveEditInjSupply,
  deleteInjSupply,
  saveAddInjSku,
  saveEditInjSku,
  saveAddPen,
  saveEditPen,
  deletePen
}
